var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 86,
    viewBox: "0 0 80 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 86,
    rx: 16,
    fill: "#426AE6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5559 37.2151H65.5264C66.7961 40.8306 66.7961 44.7706 65.5264 48.3862H65.5546C66.0296 48.3862 66.4999 48.2926 66.9386 48.1108C67.3774 47.9291 67.776 47.6626 68.1117 47.3268C68.4474 46.9909 68.7136 46.5922 68.895 46.1535C69.0765 45.7147 69.1696 45.2445 69.1692 44.7698V40.8282C69.1692 39.8702 68.7886 38.9514 68.111 38.2738C67.4334 37.5963 66.5144 37.2154 65.5559 37.2151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4445 37.2151C13.4856 37.2151 12.5659 37.5956 11.8875 38.2731C11.2091 38.9506 10.8275 39.8696 10.8267 40.8282V44.7698C10.8267 45.2447 10.9202 45.715 11.1021 46.1537C11.2839 46.5925 11.5504 46.9911 11.8863 47.327C12.2223 47.6628 12.6211 47.9292 13.06 48.1109C13.499 48.2926 13.9694 48.3862 14.4445 48.3862H14.4721C13.2033 44.7705 13.2033 40.8308 14.4721 37.2151H14.4445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7461 27.2712H48.1031V27.1864C48.1031 26.6637 47.8953 26.1625 47.5256 25.7929C47.1559 25.4233 46.6544 25.2156 46.1315 25.2156H42.4354C42.4352 24.683 42.2602 24.1651 41.9374 23.7414C41.6145 23.3176 41.1615 23.0115 40.6478 22.8697V17.8501C41.2149 17.6935 41.7059 17.3367 42.0299 16.8458C42.3538 16.355 42.4888 15.7634 42.4097 15.1806C42.3307 14.5979 42.0429 14.0636 41.5999 13.6767C41.1568 13.2899 40.5884 13.0767 40.0001 13.0767C39.4118 13.0767 38.8435 13.2899 38.4004 13.6767C37.9574 14.0636 37.6696 14.5979 37.5906 15.1806C37.5115 15.7634 37.6465 16.355 37.9704 16.8458C38.2944 17.3367 38.7854 17.6935 39.3525 17.8501V22.8717C38.839 23.0136 38.3862 23.3199 38.0635 23.7436C37.7407 24.1673 37.5658 24.6851 37.5656 25.2176H33.8695C33.3466 25.2176 32.8451 25.4252 32.4754 25.7948C32.1056 26.1644 31.8979 26.6657 31.8979 27.1884V27.2731H30.2549C21.6745 27.2731 14.7188 34.2261 14.7188 42.8023C14.7188 51.3792 21.6745 58.3321 30.2549 58.3321H49.7461C58.3258 58.3321 65.2816 51.3792 65.2816 42.8023C65.2816 34.2241 58.3258 27.2712 49.7461 27.2712ZM49.7461 50.4759H30.2549C29.2406 50.4853 28.2345 50.2937 27.2946 49.9122C26.3548 49.5307 25.4999 48.9668 24.7794 48.2532C24.0588 47.5395 23.4868 46.6902 23.0965 45.7544C22.7061 44.8185 22.5052 43.8146 22.5052 42.8007C22.5052 41.7867 22.7061 40.7828 23.0965 39.847C23.4868 38.9111 24.0588 38.0618 24.7794 37.3482C25.4999 36.6345 26.3548 36.0707 27.2946 35.6892C28.2345 35.3076 29.2406 35.116 30.2549 35.1254H49.7461C50.7604 35.116 51.7665 35.3076 52.7063 35.6892C53.6461 36.0707 54.501 36.6345 55.2216 37.3482C55.9421 38.0618 56.5141 38.9111 56.9045 39.847C57.2948 40.7828 57.4958 41.7867 57.4958 42.8007C57.4958 43.8146 57.2948 44.8185 56.9045 45.7544C56.5141 46.6902 55.9421 47.5395 55.2216 48.2532C54.501 48.9668 53.6461 49.5307 52.7063 49.9122C51.7665 50.2937 50.7604 50.4853 49.7461 50.4759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3972 40.647C32.0406 40.647 31.6875 40.7172 31.358 40.8536C31.0285 40.99 30.7292 41.19 30.477 41.442C30.2248 41.6941 30.0248 41.9933 29.8883 42.3226C29.7519 42.652 29.6816 43.0049 29.6816 43.3614C29.6816 44.8612 30.8975 44.9545 32.3972 44.9545C33.8969 44.9545 35.1134 44.8612 35.1134 43.3614C35.1134 43.0049 35.0431 42.6519 34.9066 42.3225C34.7701 41.9931 34.57 41.6938 34.3178 41.4418C34.0656 41.1897 33.7661 40.9898 33.4366 40.8534C33.107 40.717 32.7538 40.6469 32.3972 40.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6029 40.647C46.8832 40.6478 46.1934 40.9342 45.6848 41.4432C45.1763 41.9521 44.8906 42.6421 44.8906 43.3614C44.8906 44.8612 46.1064 44.9545 47.6062 44.9545C49.1059 44.9545 50.3224 44.8612 50.3224 43.3614C50.3224 43.0046 50.252 42.6513 50.1153 42.3217C49.9786 41.9921 49.7782 41.6927 49.5256 41.4406C49.273 41.1885 48.9732 40.9886 48.6433 40.8525C48.3134 40.7163 47.9598 40.6465 47.6029 40.647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_1058",
    x1: 40.0003,
    y1: -1.18812,
    x2: 40.0003,
    y2: 87.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0039BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_286",
    x1: 2,
    y1: 2.5,
    x2: 88,
    y2: 82.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#426AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1efb53b6ecae308e915608e0a0bdec9c.svg";
export { ForwardRef as ReactComponent };